import { render, staticRenderFns } from "./TripUtiWagonsListsPanel.vue?vue&type=template&id=6688eaab&scoped=true&"
import script from "./TripUtiWagonsListsPanel.vue?vue&type=script&lang=js&"
export * from "./TripUtiWagonsListsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6688eaab",
  null
  
)

export default component.exports